// extracted by mini-css-extract-plugin
export default {"geninput":"GenInput_geninput__4Bc4h","content":"GenInput_content__Qcrc1","innerinput":"GenInput_innerinput__IKJjR"};